import React from 'react';
import { MoonshotBilling } from './MoonshotBilling';
import { MoonshotEmailVerification } from './MoonshotEmailVerification';
import { MoonshotSubmitFunction } from './types';
import { useMoonshotBillingQuery } from '@trello/graphql/generated';
import styles from './MoonshotPayment.less';

interface MoonshotPaymentProps {
  onSubmit: MoonshotSubmitFunction;
}

export const MoonshotPayment: React.FC<MoonshotPaymentProps> = ({
  onSubmit,
}) => {
  const { data } = useMoonshotBillingQuery();
  const isConfirmed = data && data.member && data.member.confirmed;
  const memberEmail = (data && data.member && data.member.email) || '';

  return (
    <div className={styles.wrapper}>
      <MoonshotBilling
        onFailure={() => {}}
        onSkip={onSubmit}
        onSuccess={onSubmit}
      />
      {isConfirmed === false && (
        <MoonshotEmailVerification email={memberEmail} />
      )}
    </div>
  );
};
